<div class="customer-filter-wrapper">
  <!-- Trigger Button (Matching Reusable Filter Pill UI) -->
  <button
    mat-flat-button
    type="button"
    class="new-sorting-btn start-sm-0"
    [matMenuTriggerFor]="customerMenuList"
    [ngClass]="{ active: isCusApply }"
    (click)="prevData()"
  >
    <div class="d-flex align-items-center">
      <div class="filter-icon-box" (click)="onIconClick($event)">
        <img src="assets/images/plus-circle.svg" alt="filter" />
      </div>

      <span class="ms-2">Customer <span *ngIf="isCusApply">| </span></span>

      <ng-container *ngIf="isCusApply">
        <h6 class="m-0 ms-1">
          <span *ngFor="let name of tempCustomerName.slice(0, 2); let i = index">
            {{ name?.contact_first_name ? (name?.contact_first_name?.length > 10 ?
            name?.contact_first_name.substring(0, 10) + '...' : name?.contact_first_name) :
            'N/A' }}<span *ngIf="i < tempCustomerName.slice(0, 2).length - 1">, </span>
          </span>
          <span *ngIf="tempCustomerName.length > 2">
            +{{ tempCustomerName.length - 2 }}
          </span>
        </h6>
      </ng-container>
    </div>
  </button>

  <!-- MatMenu Popover (Exact Reusable Filter Popover UI) -->
  <mat-menu
    #customerMenuList="matMenu"
    class="customer-filter-menu-panel mt-1"
    xPosition="before"
    (menuOpened)="onMenuOpened()"
  >
    <div class="customer-filter-popover" (click)="$event.stopPropagation()">
      <p class="customer-filter-title">Filter by Customer</p>

      <!-- Search in options -->
      <div class="customer-filter-search">
        <div class="customer-search-box">
          <svg class="customer-search-icon" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#94a3b8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.5 17.5L13.875 13.875" stroke="#94a3b8" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input
            type="text"
            class="customer-search-input"
            [(ngModel)]="searchCustomer"
            placeholder="Search by customer name"
            (click)="$event.stopPropagation()"
            (keyup)="applyFilter($event)"
          />
          <button
            type="button"
            *ngIf="searchCustomer"
            class="customer-search-clear"
            (click)="clearSearch($event)"
          >
            &times;
          </button>
        </div>
      </div>

      <!-- Options List using unified app-checkbox -->
      <div class="customer-options-list">
        <div
          *ngFor="let item of filterCustomer"
          class="customer-option-item"
          (click)="toggleCustomer(item, $event)"
        >
          <app-checkbox
            [checked]="item.isSelected"
            [labelText]="item?.contact_first_name ? (item?.contact_first_name?.length > 20 ? item?.contact_first_name.substring(0, 20) + '...' : item?.contact_first_name) : 'N/A'"
            (click)="$event.stopPropagation()"
            (checkboxChange)="toggleCustomer(item)"
          ></app-checkbox>
        </div>
        <div *ngIf="filterCustomer?.length === 0" class="customer-no-options">
          No customer found
        </div>
      </div>

      <!-- Action Button using app-primary-button -->
      <div class="customer-filter-actions">
        <app-primary-button
          label="Apply"
          size="medium"
          [fullWidth]="true"
          [disabled]="customerId?.length < 1"
          (btnClick)="filterByCustomer($event)"
        ></app-primary-button>
      </div>
    </div>
  </mat-menu>
</div>